
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/leads/[[...listingAlias]]",
      function () {
        return require("private-next-pages/leads/[[...listingAlias]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/leads/[[...listingAlias]]"])
      });
    }
  